<script setup lang="ts">
import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Heading from "@/components/Heading.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";

const user: { name: string } = pb.authStore.model;

</script>

<template>
  <Title>Events</Title>

  <Divider/>

  <Content>
    <Heading>Archive</Heading>

    <div class="grid lg:grid-cols-2 gap-2 lg:gap-5">
      <LinkBox route="retreat-2025" title="R&D Retreat 2025" description="Our first in-person multi-day retreat, hosted in Berlin." />
      <LinkBox route="technology-day-2024" title="Technology Day 2025" description="Our first one-day online conference held by and for TSG R&D teams." />
    </div>
  </Content>
</template>

